(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/pages/result.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/pages/result.js');

'use strict';

const {
  useState,
  useEffect,
  useMemo
} = React;
const ErrorDialog = svs.grassroots.components.ErrorDialog;
const {
  Loader
} = svs.components.ReactLoader;
const {
  ResultProvince,
  ResultCountry,
  ResultSport
} = svs.grassroots.components.result;
const {
  SearchResults
} = svs.grassroots.pages;
const {
  useParams,
  useHistory
} = ReactRouterDOM;
const {
  ReactForm: {
    RadioGroup,
    RadioButton,
    Select,
    Option,
    Form,
    ControlGroup
  }
} = svs.ui;
const {
  grassrootsQueryApi
} = svs.grassroots.store;
const Result = () => {
  const [cms, setCms] = useState(undefined);
  const [view, setView] = useState('sverige');
  const [provinces, setProvinces] = useState([]);
  const [viewDetail, setViewDetail] = useState({});
  const [sports, setSports] = useState([]);
  const views = useMemo(() => ['sverige', 'lan', 'forening', 'idrott'], []);
  const {
    year: paramYear,
    view: paramView,
    viewDetail: paramViewDetail
  } = useParams();
  const history = useHistory();
  const response = grassrootsQueryApi.useFetchResultProvinceAndSportsQuery();
  const cmsYearlyContent = svs.grassroots_shared_2.data.config.result.sort((a, b) => b.year - a.year);
  const decodeUrlId = p => p.toLowerCase().replace(/\s/g, '-').replace(/[åä]/g, 'a').replace(/ö/g, 'o');

  useEffect(() => {
    setCms(cmsYearlyContent.find(c => c.year.toString() === paramYear && c.publish));
  }, [cmsYearlyContent, paramYear]);

  useEffect(() => {
    if (paramView) {
      setView(views.find(v => v === paramView));
    }
  }, [paramView, views]);

  useEffect(() => {
    if (response.isSuccess && response.data) {
      const newProvinces = response.data.provinces.map(p => ({
        name: p,
        id: decodeUrlId(p)
      }));
      const newSports = response.data.sports.map(s => ({
        name: s,
        id: decodeUrlId(s)
      }));
      setProvinces(newProvinces);
      setSports(newSports);

      if (paramView === 'lan') {
        if (paramViewDetail) {
          const match = newProvinces.find(p => paramViewDetail === p.id);
          if (match) {
            setViewDetail(match);
          }
        } else {
          setViewDetail(newProvinces[0]);
        }
      }

      if (paramView === 'idrott') {
        if (paramViewDetail) {
          const match = newSports.find(p => paramViewDetail === p.id);
          if (match) {
            setViewDetail(match);
          }
        } else {
          setViewDetail(newSports[0]);
        }
      }
    }
  }, [paramView, paramViewDetail, response.data, response.isSuccess]);
  const onChangeHandler = e => {
    history.push("/sagickdet/".concat(paramYear, "/").concat(e));
    setView(e);
  };
  const onViewDetailChangeHandler = e => {
    const id = decodeUrlId(e.target.value);
    setViewDetail({
      name: e.target.value,
      id
    });
    history.push("/sagickdet/".concat(paramYear, "/").concat(paramView, "/").concat(id));
  };
  const onYearChangeHandler = e => {
    if (e.target.value.toString() !== paramYear) {
      if (view === 'lan') {
        if (viewDetail) {
          history.push("/sagickdet/".concat(e.target.value, "/").concat(view, "/").concat(viewDetail.id));
        }
      } else {
        history.push("/sagickdet/".concat(e.target.value, "/").concat(view));
      }
    }
  };

  if (response.isLoading) {
    return React.createElement(Loader, {
      size: 300
    });
  }
  if (cms && view) {
    return React.createElement("div", {
      className: "".concat(svs.grassroots.background, " f-content padding-1")
    }, React.createElement("div", {
      className: "result-container"
    }, React.createElement(RadioGroup, {
      branding: svs.grassroots.tenant,
      className: "margin-bottom-1",
      size: 200
    }, React.createElement(RadioButton, {
      checked: view === 'sverige',
      onChange: onChangeHandler,
      value: "sverige"
    }, "SVERIGE"), React.createElement(RadioButton, {
      checked: view === 'lan',
      onChange: onChangeHandler,
      value: "lan"
    }, "L\xC4N"), React.createElement(RadioButton, {
      checked: view === 'forening',
      onChange: onChangeHandler,
      value: "forening"
    }, "F\xD6RENING"), React.createElement(RadioButton, {
      checked: view === 'idrott',
      onChange: onChangeHandler,
      value: "idrott"
    }, "IDROTT")), React.createElement(Form, null, React.createElement(ControlGroup, {
      isLessSpace: true,
      v2: true
    }, (view === 'sverige' || view === 'lan') && React.createElement(Select, {
      label: "S\xE5 h\xE4r gick det \xE5r ".concat(paramYear),
      onChange: onYearChangeHandler,
      v2: true,
      value: paramYear
    }, cmsYearlyContent.map(result => React.createElement(Option, {
      id: result.year,
      key: result.year,
      name: result.year,
      value: result.year.toString()
    }, result.year))), view === 'sverige' && React.createElement(ResultCountry, {
      cms: cms
    }), view === 'lan' && provinces.length > 0 && React.createElement(ResultProvince, {
      cms: cms,
      currentProvince: viewDetail,
      provinces: provinces,
      setCurrentProvince: onViewDetailChangeHandler
    }), view === 'forening' && React.createElement("div", {
      className: "margin-top-3"
    }, React.createElement(SearchResults, {
      resultPage: true
    })), view === 'idrott' && provinces.length > 0 && React.createElement(ResultSport, {
      cms: cms,
      currentSport: viewDetail,
      setCurrentSport: onViewDetailChangeHandler,
      sports: sports
    })))));
  }
  return React.createElement(ErrorDialog, null);
};
svs.grassroots.pages.Result = Result;

 })(window);